(function () {
  function markExistingControls() {
    document.querySelectorAll('.engrave-cart-wrap, .engrave-cart-clear, .make-a-gift-cta, .make-a-gift-clear').forEach(function (control) {
      control.dataset.engraveBound = 'true';
    });
  }

  function closeCartDrawer(target) {
    var drawer = target.closest('cart-drawer') || document.querySelector('cart-drawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('.engrave-cart-wrap, .engrave-cart-clear, .make-a-gift-cta, .make-a-gift-clear')) {
      closeCartDrawer(event.target);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', markExistingControls);

  document.addEventListener('click', async function (event) {
    var engraveButton = event.target.closest('.engrave-cart-wrap');
    if (engraveButton && !engraveButton.dataset.engraveBound) {
      engraveButton.dataset.engraveBound = 'true';
      event.preventDefault();
      if (typeof engraveOpen === 'function') {
        engraveOpen(engraveButton.dataset.position, engraveButton);
      }
      return;
    }

    var clearButton = event.target.closest('.engrave-cart-clear');
    if (!clearButton || clearButton.dataset.engraveBound) return;

    clearButton.dataset.engraveBound = 'true';
    event.preventDefault();

    var position = clearButton.dataset.clearPosition;
    var sourceButton = document.getElementById('openDrawerButton-' + position);
    if (!sourceButton || typeof initialCheck !== 'function') return;

    await initialCheck(
      position,
      sourceButton.dataset.engravecolors,
      sourceButton.dataset.engraveimage,
      sourceButton.dataset.engravecharactercount
    );

    var modal = document.getElementById('myEngraveModal');
    var cancelButton = document.getElementById('engrave-drawer-cancel');
    var closeButton = modal && modal.querySelector('.close');
    var removeButton = document.getElementById('engrave-remove-gift-wrap');
    if (!modal || !removeButton) return;

    modal.style.display = 'flex';

    var cancelRemoval = function () {
      modal.style.display = 'none';
      removeButton.onclick = null;
      if (closeButton) closeButton.onclick = null;
      if (cancelButton) cancelButton.onclick = null;
    };

    var confirmRemoval = async function () {
      if (!amCartItems || !amCartItems[position]) return;

      var response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: amCartItems[position].key,
          properties: {
            _engravingText: '',
            _engravingStyle: '',
            _engravingColor: '',
            _engravingConfirmation: '',
            'gift-wrap-color': amCartItems[position].properties['gift-wrap-color'],
            'gift-wrap-add-message': amCartItems[position].properties['gift-wrap-add-message'],
            'gift-wrap-from': amCartItems[position].properties['gift-wrap-from'],
            'gift-wrap-to': amCartItems[position].properties['gift-wrap-to'],
            'gift-wrap-message': amCartItems[position].properties['gift-wrap-message']
          }
        })
      });

      var cart = await response.json();
      modal.style.display = 'none';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    };

    removeButton.onclick = confirmRemoval;
    if (cancelButton) cancelButton.onclick = cancelRemoval;
    if (closeButton) closeButton.onclick = cancelRemoval;
  });
})();
